import QualificationMasterContainer from "../../container/admin/qualification-master";

const QualificationMaster = () => {
    return <QualificationMasterContainer />;
};

export default QualificationMaster;